import React from 'react';
import { PopoverState } from './types';

export const PopoverContext = React.createContext<PopoverState | null>(null);
